<template>
  <div class="flex flex-col gap-1.5">
    <div class="flex items-center justify-between">
      <span class="text-xs font-semibold text-gray-500">
        {{ attribute.attribute_display_name }}
      </span>
      <div class="flex gap-[5px] items-center">
        <button
          v-tooltip.right="$t('CUSTOM_ATTRIBUTES.ACTIONS.EDIT')"
          class-names="size-4 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-colors"
          @click="onEdit"
        >
          <span class="material-symbols-outlined text-[16px] cursor-pointer">
            edit
          </span>
        </button>
        <button
          v-if="!isAttributeTypeCheckbox"
          v-tooltip="$t('CUSTOM_ATTRIBUTES.ACTIONS.COPY')"
          class="size-4 flex items-center justify-center text-gray-500 hover:text-gray-700 transition-colors"
          @click="onCopy"
        >
          <span class="material-symbols-outlined text-[16px] cursor-pointer">
            content_copy
          </span>
        </button>
        <button
          v-tooltip.left="$t('CUSTOM_ATTRIBUTES.ACTIONS.DELETE')"
          class="size-4 flex items-center justify-center text-gray-500 hover:text-red-500 transition-colors"
          @click="onDelete"
        >
          <span
            class="material-symbols-outlined text-[19px]/[16px] w-4 cursor-pointer"
          >
            delete
          </span>
        </button>
      </div>
    </div>

    <div v-if="!isAttributeTypeCheckbox" class="leading-4">
      <a
        v-if="isAttributeTypeLink"
        :href="hrefURL"
        target="_blank"
        rel="noopener noreferrer"
        class="text-xs leading-4 break-all text-blue-400 hover:text-blue-500"
      >
        {{ urlValue }}
      </a>
      <span v-else class="text-xs leading-4 break-all text-gray-800">
        {{ displayValue || '---' }}
      </span>
    </div>

    <div v-else>
      <label class="flex items-center gap-2">
        <input
          :checked="displayValue"
          type="checkbox"
          class="my-0 !mr-0 semantic-checkbox"
          @click.prevent
        />
        <span class="text-black text-sm">{{
          attribute.attribute_description
        }}</span>
      </label>
    </div>
  </div>
</template>

<script>
import { isValidURL } from 'dashboard/helper/URLHelper.js';

export default {
  props: {
    attribute: { type: Object, default: () => {} },
    contactId: { type: Number, default: null },
  },
  computed: {
    displayValue() {
      if (this.isAttributeTypeDate) {
        const date = new Date(this.attribute.value || new Date());
        const d = String(date.getDate()).padStart(2, '0');
        const m = String(date.getMonth() + 1).padStart(2, '0');
        const y = date.getFullYear();
        return `${d}/${m}/${y}`;
      }
      if (this.isAttributeTypeCheckbox) {
        return this.attribute.value === 'false' ? false : this.attribute.value;
      }
      return this.attribute.value;
    },
    isAttributeTypeCheckbox() {
      return this.attribute.attribute_display_type === 'checkbox';
    },
    isAttributeTypeLink() {
      return this.attribute.attribute_display_type === 'link';
    },
    isAttributeTypeDate() {
      return this.attribute.attribute_display_type === 'date';
    },
    urlValue() {
      return isValidURL(this.attribute.value) ? this.attribute.value : '---';
    },
    hrefURL() {
      return isValidURL(this.attribute.value) ? this.attribute.value : '';
    },
  },
  methods: {
    onDelete() {
      this.$emit('delete', this.attribute.attribute_key);
    },
    onCopy() {
      this.$emit('copy', this.attribute.value);
    },
    onEdit() {
      this.$emit('edit', {
        attribute: this.attribute,
        contactId: this.contactId,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .selector-wrap {
    @apply m-0 top-1;
    .selector-name {
      @apply ml-0;
    }
  }
  .name {
    @apply ml-0;
  }
}
</style>
